export const objs: { [key: string]: any } = {};